import React, { useState, useEffect } from "react";
import { createPortal, render } from "react-dom";
import { StateContext } from "./state";
import { Input } from "./input";

let properties;
if (drupalSettings.is_sabre) {
  properties = JSON.parse(
    drupalSettings.centara_sabre.booknow_property_data
  );
}
else {
  properties = JSON.parse(
    drupalSettings.centara_fastbooking.booknow_property_data
  );
}

export default function App() {
  const [activeSearch, setActiveSearch] = useState(null);
  const [hotels, setHotels] = useState({
    1: JSON.parse(localStorage.getItem('hotelsHandlers'))? JSON.parse(localStorage.getItem('hotelsHandlers'))[1] : null,
    2: JSON.parse(localStorage.getItem('hotelsHandlers'))? JSON.parse(localStorage.getItem('hotelsHandlers'))[2] : null,
    3: JSON.parse(localStorage.getItem('hotelsHandlers'))? JSON.parse(localStorage.getItem('hotelsHandlers'))[3] : null,
  });

  const activeSearchHandler = (idx) => {
    setActiveSearch(idx === activeSearch ? null : idx);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const query_param = params.get('property');
    if (query_param) {
      handleClickCode(query_param);
    }
  }, []);
  const handleClickCode = (code) => {
    const hotel = properties.find((i) => i.ppty_code.toLowerCase() === code.toLowerCase());
    if (hotel) {
      setHotelsHandler(hotel, 1);
    }
  };

  const setHotelsHandler = (hotel, activeHotel) => {
    var existing_hotel = localStorage.getItem('hotelsHandlers');
    existing_hotel = existing_hotel ? JSON.parse(existing_hotel) : {};
    existing_hotel[activeHotel] = hotel;
    localStorage.setItem('hotelsHandlers', JSON.stringify(existing_hotel));
    setHotels((hotels) => ({ ...hotels, [activeHotel]: hotel }));
  };

  const disableSearchHandler = () => {
    setActiveSearch(null);
  };

  const removeHotel = (index) => {
    var remove_hotel = localStorage.getItem('hotelsHandlers');
    remove_hotel = remove_hotel ? JSON.parse(remove_hotel) : {};
    remove_hotel[index] = null;
    localStorage.setItem('hotelsHandlers', JSON.stringify(remove_hotel));
    setHotels((hotels) => ({ ...hotels, [index]: null }));
  };

  const inputs = document.querySelectorAll(".hotel-listing-select");
  const portals = [...inputs].map((el, idx) => {
    return createPortal(
      <Input
        activeSearchHandler={activeSearchHandler}
        disableSearchHandler={disableSearchHandler}
        index={idx + 1}
      />,
      el
    );
  });

  return (
    <StateContext.Provider
      value={{
        hotels,
        properties,
        activeSearch,
        setHotelsHandler,
        removeHotel,
      }}
    >
      {portals}
    </StateContext.Provider>
  );
}

const rootElement = document.getElementById("hotel-listing-root");
if (rootElement) {
  render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    rootElement
  );
}
